import { TOfferType } from 'shared/types/api-models/offer-card/v1/get-offer-data';

import { IState } from '../../../store';

export const selectOfferType = (state: IState): TOfferType => state.offerData.offer.offerType;
